import type { ReactNode } from 'react';
import { Spinner } from 'react-bootstrap';
import { Navigate, useParams } from 'react-router-dom';
import type { Params } from 'react-router-dom';
import { useFulfillmentV2Launch } from '@/infrastructure/FulfillmentV2Launch';

interface RetiredOnFulfillmentV2LaunchProps {
  /** The Fulfillment 2.0 screen that replaces this one, built from the route's own params. */
  to: (params: Readonly<Params<string>>) => string;
  children: ReactNode;
}

/**
 * An OMS Center order or stock screen that goes away once Fulfillment V2 is launched (SSD-7090): its URL
 * then lands on the 2.0 screen instead. Nothing renders until the switch is read, because the V1 screen
 * would start reading V1 the moment it mounts.
 */
export const RetiredOnFulfillmentV2Launch = ({ to, children }: RetiredOnFulfillmentV2LaunchProps) => {
  const launch = useFulfillmentV2Launch();
  const params = useParams();
  if (launch === 'unknown') {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" size="sm" role="status" aria-label="Loading" />
      </div>
    );
  }
  if (launch === 'on') {
    return <Navigate to={to(params)} replace />;
  }
  return <>{children}</>;
};
